import component from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-calculations/lni-janitorial-calculations.component.vue';
import module from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-calculations/lni-janitorial-calculations.module.js';

export default {
    component,
    module,
};